import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useToast } from 'components/ui/use-toast';
import { useUndoDelete } from 'modules/trash';
import * as Api from '../api';

const useDelete = () => {
  const queryClient = useQueryClient();
  const { toast } = useToast();
  const { t } = useTranslation();
  const undoable = useUndoDelete();

  return useMutation({
    mutationFn: async (id: string) => {
      await Api.remove(id);
    },
    onSuccess: (_data, id) => {
      queryClient.invalidateQueries({ queryKey: ['collections'] });
      queryClient.invalidateQueries({ queryKey: ['test'] });
      undoable({ type: 'collection', ids: [id], title: t('trash.deleted_collection') });
    },
    onError: (error: any) => {
      toast.error('Error', {
        description: error?.response?.data?.message || 'Failed to delete collection',
      });
    },
  });
};

export default useDelete;
